module.exports = __webpack_public_path__ + "img/apple2.09e24bd1.png";